import { defineComponent, openBlock, createElementBlock, createBlock, unref, withCtx, createTextVNode, toDisplayString, createCommentVNode } from "vue";
import { CdrLink } from "@rei/cedar";
const _hoisted_1 = {
  id: "product-page-title",
  class: "product-title",
  tag: "h1",
  modifier: "heading-serif-600"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductTitle",
  props: {
    link: {
      default: ""
    },
    name: {
      default: ""
    },
    title: {}
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const sendMetrics = (event) => {
      emit("metricsClick", {
        linkName: "brands",
        link: props.link,
        event
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("h1", _hoisted_1, [_ctx.name && _ctx.link ? (openBlock(), createBlock(unref(CdrLink), {
        key: 0,
        id: "product-brand-link",
        "inherit-color": true,
        class: "product-brand__link",
        tag: "a",
        href: _ctx.link,
        onClick: _cache[0] || (_cache[0] = ($event) => sendMetrics($event))
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.name) + "  ", 1)]),
        _: 1
      }, 8, ["href"])) : createCommentVNode("", true), createTextVNode(" " + toDisplayString(_ctx.title), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductTitle2.mjs.map
